// third-party
import { FormattedMessage } from 'react-intl';

// project-imports
import { NavItemType } from '@/types/bs-types/menu';

// assets
import {
  Add,
  Link1,
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  Graph,
  Chart21,
  Map1,
  Refresh,
  Home3,
  HomeTrendUp,
  Box1,
  Book,
  PasswordCheck,
  Next,
  RowVertical,
  CpuCharge,
  TableDocument,
  Subtitle,
  Book1,
  I24Support,
  Security,
  MessageProgramming,
  DollarSquare,
  Airplane,
  DocumentCode2,
  OceanProtocol,
  Level,
  ShieldCross,
  InfoCircle,
  Driving,
  Story,
  Fatrows,
  PresentionChart
} from 'iconsax-react';

// icons
const icons = {
  applications: KyberNetwork,
  chat: Messages2,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag,
  add: Add,
  link: Link1,
  charts: Chart21,
  chart: Graph,
  map: Map1,
  navigation: Home3,
  dashboard: HomeTrendUp,
  components: Box1,
  loading: Refresh,
  formsTable: Book,
  validation: PasswordCheck,
  wizard: Next,
  layout: RowVertical,
  plugins: CpuCharge,
  reactTables: TableDocument,
  muiTables: Subtitle,
  page: Book1,
  authentication: Security,
  maintenance: MessageProgramming,
  pricing: DollarSquare,
  contactus: I24Support,
  landing: Airplane,
  samplePage: DocumentCode2,
  menuLevel: OceanProtocol,
  menuLevelSubtitle: Level,
  disabledMenu: ShieldCross,
  chipMenu: InfoCircle,
  documentation: I24Support,
  roadmap: Driving,
  widgets: Story,
  statistics: Story,
  data: Fatrows,
  chart2: PresentionChart
};

const rootPath = '/example';

// ==============================|| MENU ITEMS - COMPONENTS ||============================== //

const menuItems: NavItemType[] = [
  {
    id: 'group-inputs',
    title: <FormattedMessage id="inputs" />,
    type: 'group',
    children: [
      {
        id: 'autocomplete',
        search: 'autocomplete, combo box, country select, grouped, multi select',
        title: <FormattedMessage id="autocomplete" />,
        type: 'item',
        url: '/components-overview/autocomplete'
      },
      {
        id: 'buttons',
        search: 'buttons, button group, icon button, toggle button, loading button',
        title: <FormattedMessage id="button" />,
        type: 'item',
        url: '/components-overview/buttons'
      },
      {
        id: 'checkbox',
        search: 'checkbox, indeterminate',
        title: <FormattedMessage id="checkbox" />,
        type: 'item',
        url: '/components-overview/checkbox'
      },
      {
        id: 'radio',
        search: 'radio',
        title: <FormattedMessage id="radio" />,
        type: 'item',
        url: '/components-overview/radio'
      },
      {
        id: 'rating',
        search: 'rating, star rating, feedback',
        title: <FormattedMessage id="rating" />,
        type: 'item',
        url: '/components-overview/rating'
      },
      {
        id: 'switch',
        search: 'switch',
        title: <FormattedMessage id="switch" />,
        type: 'item',
        url: '/components-overview/switch'
      },
      {
        id: 'select',
        search: 'select, multi-select',
        title: <FormattedMessage id="select" />,
        type: 'item',
        url: '/components-overview/select'
      },
      {
        id: 'slider',
        search: 'slider, range',
        title: <FormattedMessage id="slider" />,
        type: 'item',
        url: '/components-overview/slider'
      },
      {
        id: 'textfield',
        search: 'textfield, input, form input, search',
        title: <FormattedMessage id="text-field" />,
        type: 'item',
        url: '/components-overview/textfield'
      }
    ]
  },
  {
    id: 'data-display',
    title: <FormattedMessage id="data-display" />,
    type: 'group',
    children: [
      {
        id: 'avatars',
        search: 'avatars, fallbacks, group avatar',
        title: <FormattedMessage id="avatar" />,
        type: 'item',
        url: '/components-overview/avatars'
      },
      {
        id: 'badges',
        search: 'badges',
        title: <FormattedMessage id="badges" />,
        type: 'item',
        url: '/components-overview/badges'
      },
      {
        id: 'chips',
        search: 'chips, tags, ',
        title: <FormattedMessage id="chip" />,
        type: 'item',
        url: '/components-overview/chips'
      },
      {
        id: 'lists',
        search: 'lists, folder list, nested list',
        title: <FormattedMessage id="list" />,
        type: 'item',
        url: '/components-overview/lists'
      },
      {
        id: 'tooltip',
        search: 'tooltip',
        title: <FormattedMessage id="tooltip" />,
        type: 'item',
        url: '/components-overview/tooltip'
      },
      {
        id: 'typography',
        search: 'typography, h1, h2,h3, h4, h5, h6, caption, subtitle, body',
        title: <FormattedMessage id="typography" />,
        type: 'item',
        url: '/components-overview/typography'
      }
    ]
  },
  {
    id: 'feedback',
    title: <FormattedMessage id="feedback" />,
    type: 'group',
    children: [
      {
        id: 'alert',
        search: 'alert',
        title: <FormattedMessage id="alert" />,
        type: 'item',
        url: '/components-overview/alert'
      },
      {
        id: 'alert-confirm',
        search: 'alert-confirm',
        title: <FormattedMessage id="alert-confirm" />,
        type: 'item',
        url: '/components-overview/alert-confirm'
      },
      {
        id: 'dialogs',
        search: 'dialogs, modal, sweetalert, confirmation box',
        title: <FormattedMessage id="dialogs" />,
        type: 'item',
        url: '/components-overview/dialogs'
      },
      {
        id: 'progress',
        search: 'progress, circular, linear, buffer',
        title: <FormattedMessage id="progress" />,
        type: 'item',
        url: '/components-overview/progress'
      },
      {
        id: 'snackbar',
        search: 'snackbar, notification, notify',
        title: <FormattedMessage id="snackbar" />,
        type: 'item',
        url: '/components-overview/snackbar'
      }
    ]
  },
  {
    id: 'navigation',
    title: <FormattedMessage id="navigation" />,
    type: 'group',
    children: [
      {
        id: 'breadcrumbs',
        search: 'breadcrumbs',
        title: <FormattedMessage id="breadcrumb" />,
        type: 'item',
        url: '/components-overview/breadcrumbs'
      },
      {
        id: 'pagination',
        search: 'pagination, table pagination',
        title: <FormattedMessage id="pagination" />,
        type: 'item',
        url: '/components-overview/pagination'
      },
      {
        id: 'speeddial',
        search: 'speeddial, speed dial, quick access button, fab button',
        title: <FormattedMessage id="speed-dial" />,
        type: 'item',
        url: '/components-overview/speeddial'
      },
      {
        id: 'stepper',
        search: 'stepper, form wizard, vertical stepper, vertical wizard',
        title: <FormattedMessage id="stepper" />,
        type: 'item',
        url: '/components-overview/stepper'
      },
      {
        id: 'tabs',
        search: 'tabs, vertical tab',
        title: <FormattedMessage id="tabs" />,
        type: 'item',
        url: '/components-overview/tabs'
      }
    ]
  },
  {
    id: 'surfaces',
    title: <FormattedMessage id="surfaces" />,
    type: 'group',
    children: [
      {
        id: 'accordion',
        search: 'accordion',
        title: <FormattedMessage id="accordion" />,
        type: 'item',
        url: '/components-overview/accordion'
      },
      {
        id: 'cards',
        search: 'cards',
        title: <FormattedMessage id="cards" />,
        type: 'item',
        url: '/components-overview/cards'
      }
    ]
  },
  {
    id: 'utils',
    title: <FormattedMessage id="utils" />,
    type: 'group',
    children: [
      {
        id: 'color',
        search: 'color',
        title: <FormattedMessage id="color" />,
        type: 'item',
        url: '/components-overview/color'
      },
      {
        id: 'date-time-picker',
        search: 'datetime, date, time date time, picker, date range picker',
        title: <FormattedMessage id="datetime" />,
        type: 'item',
        url: '/components-overview/date-time-picker'
      },
      {
        id: 'date-time-picker-BE',
        search: 'datetime, date, time date time, picker, date range picker',
        title: <FormattedMessage id="dateTimeBE" />,
        type: 'item',
        url: '/components-overview/date-time-picker-BE'
      },
      {
        id: 'modal',
        search: 'modal, dialog',
        title: <FormattedMessage id="modal" />,
        type: 'item',
        url: '/components-overview/modal'
      },
      {
        id: 'shadows',
        search: 'shadows, color shadow',
        title: <FormattedMessage id="shadow" />,
        type: 'item',
        url: '/components-overview/shadows'
      },
      {
        id: 'timeline',
        search: 'timeline, list of event',
        title: <FormattedMessage id="timeline" />,
        type: 'item',
        url: '/components-overview/timeline'
      },
      {
        id: 'treeview',
        search: 'treeview, email clone',
        title: <FormattedMessage id="treeview" />,
        type: 'item',
        url: '/components-overview/treeview'
      }
    ]
  },
  {
    id: 'extended',
    title: 'Extended',
    type: 'group',
    children: [
      {
        id: 'export-pdf',
        search: 'export pdf',
        title: 'Export Pdf',
        type: 'item',
        url: '/components-overview/export-pdf'
      },
      {
        id: 'crop-image',
        search: 'crop image',
        title: 'Crop Image',
        type: 'item',
        url: '/components-overview/crop-image'
      },
      {
        id: 'mod-table',
        search: 'table,umbrella table,extended table',
        title: 'React Extended Table',
        type: 'item',
        url: '/components-overview/mod-table'
      }
    ]
  },
  {
    id: 'backend',
    title: 'Backend',
    type: 'group',
    children: [
      {
        id: 'enc-file',
        search: 'encrypt, decrypt, file',
        title: 'Encrypt Decrypt File',
        type: 'item',
        url: '/backend/enc'
      }
    ]
  },
  {
    id: 'icons',
    title: <FormattedMessage id="icons" />,
    type: 'group',
    children: [
      {
        id: 'iconsax',
        search: 'icon, iconsax',
        title: <FormattedMessage id="iconsax" />,
        type: 'item',
        url: '/components-overview/iconsax'
      },
      {
        id: 'themify',
        search: 'icon, themify',
        title: <FormattedMessage id="themify" />,
        type: 'item',
        url: '/components-overview/icon-themify'
      },
      {
        id: 'fontawesome',
        search: 'icon, fontawesome',
        title: <FormattedMessage id="fontawesome" />,
        type: 'item',
        url: '/components-overview/icon-fontawesome'
      },
      {
        id: 'radix',
        search: 'icon, radix',
        title: <FormattedMessage id="radix" />,
        type: 'item',
        url: '/components-overview/icon-radix'
      },
      {
        id: 'simple',
        search: 'icon, simple',
        title: <FormattedMessage id="simple" />,
        type: 'item',
        url: '/components-overview/icon-simple'
      },
      {
        id: 'hero2',
        search: 'icon, hero2',
        title: <FormattedMessage id="hero2" />,
        type: 'item',
        url: '/components-overview/icon-hero2'
      },
      {
        id: 'bootstrap',
        search: 'icon, bootstrap',
        title: <FormattedMessage id="bootstrap" />,
        type: 'item',
        url: '/components-overview/icon-bootstrap'
      },
      {
        id: 'blueseas',
        search: 'icon, bootstrap',
        title: <FormattedMessage id="Blueseas" />,
        type: 'item',
        url: '/components-overview/icon-blueseas'
      }
    ]
  },
  {
    id: 'group-forms-tables',
    title: <FormattedMessage id="forms-tables" />,
    icon: icons.formsTable,
    type: 'group',
    children: [
      {
        id: 'validation',
        title: <FormattedMessage id="forms-validation" />,
        type: 'item',
        url: `/components-overview/forms/validation`,
        icon: icons.validation
      },
      {
        id: 'wizard',
        title: <FormattedMessage id="forms-wizard" />,
        type: 'item',
        url: `/components-overview/forms/wizard`,
        icon: icons.wizard
      }
      // {
      //   id: 'forms-layout',
      //   title: <FormattedMessage id="layout" />,
      //   type: 'collapse',
      //   icon: icons.layout,
      //   children: [
      //     {
      //       id: 'basic',
      //       title: <FormattedMessage id="basic" />,
      //       type: 'item',
      //       url: `/components-overview/forms/layout/basic`
      //     },
      //     {
      //       id: 'multi-column',
      //       title: <FormattedMessage id="multi-column" />,
      //       type: 'item',
      //       url: `/components-overview/forms/layout/multi-column`
      //     },
      //     {
      //       id: 'action-bar',
      //       title: <FormattedMessage id="action-bar" />,
      //       type: 'item',
      //       url: `/components-overview/forms/layout/action-bar`
      //     },
      //     {
      //       id: 'sticky-bar',
      //       title: <FormattedMessage id="sticky-bar" />,
      //       type: 'item',
      //       url: `/components-overview/forms/layout/sticky-bar`
      //     }
      //   ]
      // },
      // {
      //   id: 'react-tables',
      //   title: <FormattedMessage id="react-table" />,
      //   type: 'collapse',
      //   icon: icons.reactTables,
      //   children: [
      //     {
      //       id: 'rt-table',
      //       title: <FormattedMessage id="basic" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/basic`
      //     },
      //     {
      //       id: 'rt-dense',
      //       title: <FormattedMessage id="dense" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/dense`
      //     },
      //     {
      //       id: 'rt-sorting',
      //       title: <FormattedMessage id="sorting" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/sorting`
      //     },
      //     {
      //       id: 'rt-filtering',
      //       title: <FormattedMessage id="filtering" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/filtering`
      //     },
      //     {
      //       id: 'rt-grouping',
      //       title: <FormattedMessage id="grouping" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/grouping`
      //     },
      //     {
      //       id: 'rt-pagination',
      //       title: <FormattedMessage id="pagination" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/pagination`
      //     },
      //     {
      //       id: 'rt-row-selection',
      //       title: <FormattedMessage id="row-selection" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/row-selection`
      //     },
      //     {
      //       id: 'rt-expanding',
      //       title: <FormattedMessage id="expanding" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/expanding`
      //     },
      //     {
      //       id: 'rt-editable',
      //       title: <FormattedMessage id="editable" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/editable`
      //     },
      //     {
      //       id: 'rt-drag-drop',
      //       title: <FormattedMessage id="drag-drop" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/drag-drop`
      //     },
      //     {
      //       id: 'rt-column-visibility',
      //       title: <FormattedMessage id="column-visibility" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/column-visibility`
      //     },
      //     {
      //       id: 'rt-column-resizing',
      //       title: <FormattedMessage id="column-resizing" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/column-resizing`
      //     },
      //     {
      //       id: 'rt-sticky-table',
      //       title: <FormattedMessage id="sticky" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/sticky-table`
      //     },
      //     {
      //       id: 'rt-umbrella',
      //       title: <FormattedMessage id="umbrella" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/umbrella`
      //     },
      //     {
      //       id: 'rt-empty',
      //       title: <FormattedMessage id="empty" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/empty`
      //     },
      //     {
      //       id: 'rt-virtualized',
      //       title: <FormattedMessage id="virtualized" />,
      //       type: 'item',
      //       url: `/components-overview/tables/react-table/virtualized`
      //     }
      //   ]
      // },
      // {
      //   id: 'mui-tables',
      //   title: <FormattedMessage id="mui-table" />,
      //   type: 'collapse',
      //   icon: icons.muiTables,
      //   children: [
      //     {
      //       id: 'mui-table',
      //       title: <FormattedMessage id="basic" />,
      //       type: 'item',
      //       url: `/components-overview/tables/mui-table/basic`
      //     },
      //     {
      //       id: 'mui-dense',
      //       title: <FormattedMessage id="dense" />,
      //       type: 'item',
      //       url: `/components-overview/tables/mui-table/dense`
      //     },
      //     {
      //       id: 'mui-enhanced',
      //       title: <FormattedMessage id="enhanced" />,
      //       type: 'item',
      //       url: `/components-overview/tables/mui-table/enhanced`
      //     },
      //     {
      //       id: 'mui-data-table',
      //       title: <FormattedMessage id="datatable" />,
      //       type: 'item',
      //       url: `/components-overview/tables/mui-table/datatable`
      //     },
      //     {
      //       id: 'mui-custom',
      //       title: <FormattedMessage id="custom" />,
      //       type: 'item',
      //       url: `/components-overview/tables/mui-table/custom`
      //     },
      //     {
      //       id: 'mui-fixed-header',
      //       title: <FormattedMessage id="fixed-header" />,
      //       type: 'item',
      //       url: `/components-overview/tables/mui-table/fixed-header`
      //     },
      //     {
      //       id: 'mui-collapse',
      //       title: <FormattedMessage id="collapse" />,
      //       type: 'item',
      //       url: `/components-overview/tables/mui-table/collapse`
      //     }
      //   ]
      // }
    ]
  },
  {
    id: 'forms-plugins',
    title: <FormattedMessage id="plugins" />,
    type: 'group',
    icon: icons.plugins,
    children: [
      {
        id: 'mask',
        title: <FormattedMessage id="mask" />,
        type: 'item',
        url: `/components-overview/forms/plugins/mask`
      },
      {
        id: 'clipboard',
        title: <FormattedMessage id="clipboard" />,
        type: 'item',
        url: `/components-overview/forms/plugins/clipboard`
      },
      {
        id: 're-captcha',
        title: <FormattedMessage id="re-captcha" />,
        type: 'item',
        url: `/components-overview/forms/plugins/re-captcha`
      },
      {
        id: 'editor',
        title: <FormattedMessage id="editor" />,
        type: 'item',
        url: `/components-overview/forms/plugins/editor`
      },
      {
        id: 'dropzone',
        title: <FormattedMessage id="dropzone" />,
        type: 'item',
        url: `/components-overview/forms/plugins/dropzone`
      }
    ]
  }
];

export default menuItems;
